import {ChatMessage, SendMessage} from "@web-libs/features/chat/domain/types/chat-message.types";

export const createGeneralOptimisticMessage = (sendMessage: SendMessage, internalReferenceId:string, senderId: string, senderName:string): ChatMessage => (
    {
        type: sendMessage.type,
        senderName: senderName,
        senderId: senderId,
        sendDate: new Date(),
        ownMessage: true,
        deliveryStatus: "pending",
        internalReferenceId: internalReferenceId
    }
)
